export default __webpack_public_path__ + "static/countryBackground-6a976998bd8a49cf2f72296373d206d7.png";